import { FaChartLine, FaBookOpen, FaMoneyBill, FaClock, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Build Your Future with Our Architecture & Design Team",
    description:
        "At Lumina Architecture & Interiors, we're looking for passionate and creative individuals to join our dynamic team. Discover fulfilling career opportunities where your ideas shape the spaces people live and work in. From visionary architecture to stunning interior design, help us redefine excellence in every project.",
    points: [
        "Opportunities in Innovative Architecture Projects",
        "Collaborate on Interior Design Concepts",
        "Training Programs in Design Technologies & Tools",
        "Real-World Project Planning & Management",
        "Contribute to Sustainable and Aesthetic Design Solutions",
    ],
    image: {
        src: images.careerIntro,
        alt: "Career-Image",
    },
};


const benefits = [
  {
    id: 1,
    icon: <FaChartLine />,
    title: "Career Advancement",
    description: "Advance your career in the dynamic field of architecture and interior design with clear growth pathways and leadership opportunities.",
  },
  {
    id: 2,
    icon: <FaBookOpen />,
    title: "Design Training Programs",
    description: "Participate in ongoing training and workshops to master the latest design trends, software, and methodologies in architecture and interiors.",
  },
  {
    id: 3,
    icon: <FaMoneyBill />,
    title: "Competitive Compensation",
    description: "Receive industry-competitive salaries and benefits as part of a rewarding career in architecture and design.",
  },
  {
    id: 4,
    icon: <FaClock />,
    title: "Flexible Work Schedules",
    description: "Enjoy flexible working hours and hybrid work options to support your creativity and work-life balance.",
  },
  {
    id: 5,
    icon: <FaHandsHelping />,
    title: "Collaborative Team Culture",
    description: "Join a supportive and creative team where collaboration fuels innovation in every design project.",
  },
  {
    id: 6,
    icon: <FaArrowUp />,
    title: "Creative Growth",
    description: "Push your creative boundaries with diverse projects and opportunities to contribute to meaningful, high-impact designs.",
  },
];


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Interior Designer',
        details: {
            location: 'Design Studio, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Interior Design or Related Field',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$65K - $80K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Create visually appealing and functional interior spaces for residential and commercial projects. Interior Designers will collaborate with clients, architects, and contractors to deliver innovative design solutions aligned with client needs and current trends.',
        ],
        responsibilities: [
            'Develop and present interior design concepts based on client requirements.',
            'Create mood boards, material palettes, and 3D renderings or sketches.',
            'Select furniture, lighting, finishes, and décor elements.',
            'Coordinate with architects, contractors, and vendors throughout the design process.',
            'Ensure designs align with budget, functionality, and aesthetic goals.',
            'Conduct site visits to oversee implementation and resolve design-related issues.',
        ],
        qualifications: [
            'Bachelor’s degree in Interior Design or a related field.',
            '2+ years of professional experience in interior design.',
            'Proficiency in design software (e.g., AutoCAD, SketchUp, Revit, Adobe Creative Suite).',
            'Strong design portfolio showcasing creativity and technical skills.',
            'Excellent communication and project management abilities.',
            'Ability to work in a fast-paced, collaborative environment.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Architectural Planner',
        details: {
            location: 'Architecture Office, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 3+ Years in Architecture or Urban Planning',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$70K - $90K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'Architectural Planners are responsible for conceptualizing and developing comprehensive architectural plans for residential, commercial, and mixed-use projects. The role involves balancing design innovation, client requirements, and regulatory compliance to deliver successful outcomes.',
        ],
        responsibilities: [
            'Develop site plans, building layouts, and architectural concepts in line with project objectives.',
            'Collaborate with engineers, interior designers, and contractors to integrate structural and design elements.',
            'Ensure compliance with zoning laws, building codes, and environmental regulations.',
            'Prepare presentations, technical reports, and design documentation for client and stakeholder reviews.',
            'Conduct feasibility studies and site assessments.',
            'Manage timelines and deliverables from design development to final construction documentation.',
        ],
        qualifications: [
            'Bachelor’s or Master’s degree in Architecture, Urban Planning, or a related field.',
            '3+ years of experience in architectural planning or design.',
            'Proficiency in AutoCAD, Revit, SketchUp, and other planning tools.',
            'Knowledge of local building codes and regulatory frameworks.',
            'Excellent spatial and analytical skills.',
            'Strong communication and team collaboration abilities.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Project Manager',
        details: {
            location: 'Design Studio, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 5+ Years in Architecture, Interior Design, or Construction Project Management',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$85K - $110K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'The Project Manager will oversee and coordinate architecture and interior design projects from concept to completion. This role demands strong leadership, organizational skills, and the ability to manage multidisciplinary teams while ensuring quality, budget, and timeline adherence.',
        ],
        responsibilities: [
            'Lead project planning and execution for architectural and interior design projects.',
            'Coordinate between clients, architects, designers, contractors, and consultants.',
            'Manage timelines, budgets, resources, and deliverables throughout project phases.',
            'Monitor on-site progress and resolve any project-related issues swiftly.',
            'Ensure compliance with design standards, safety protocols, and building regulations.',
            'Prepare and present status reports and project documentation to stakeholders.',
        ],
        qualifications: [
            'Bachelor’s degree in Architecture, Interior Design, Civil Engineering, or related field.',
            '5+ years of proven experience in managing design or construction projects.',
            'Strong knowledge of architecture and interior design processes.',
            'Excellent leadership, communication, and negotiation skills.',
            'Proficiency in project management tools (e.g., MS Project, Primavera) and design software (e.g., AutoCAD, Revit).',
            'Ability to multitask and manage multiple high-value projects simultaneously.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Interior Stylist',
        details: {
            location: 'Design Studio, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Interior Styling or Visual Merchandising',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'As an Interior Stylist, you will bring creative vision to life by selecting decor, furnishings, and accents that align with our clients’ aesthetic preferences. You’ll collaborate closely with designers and clients to enhance the visual and emotional appeal of interior spaces.',
        ],
        responsibilities: [
            'Curate and arrange furniture, art, and decor to achieve desired aesthetics.',
            'Collaborate with designers to implement the final stages of interior projects.',
            'Source and procure decorative items and accessories that complement the design.',
            'Stay updated on trends in color theory, materials, and visual presentation.',
            'Stage spaces for client presentations, photography, or public display.',
            'Ensure styling aligns with brand identity and client goals.',
        ],
        qualifications: [
            'Degree or diploma in Interior Design, Visual Arts, or a related field preferred.',
            '2+ years of experience in interior styling or visual merchandising.',
            'Strong eye for detail, composition, and spatial harmony.',
            'Excellent knowledge of current design and decor trends.',
            'Strong interpersonal and client-facing communication skills.',
            'Ability to work under pressure and meet tight styling deadlines.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Project Coordinator',
        details: {
            location: 'Design Office, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Project Coordination or Design Project Support',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$55K - $70K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'The Project Coordinator plays a key role in supporting the planning, execution, and delivery of architecture and interior design projects. This role involves coordinating between departments, managing timelines, and ensuring all project components align seamlessly to achieve client satisfaction.',
        ],
        responsibilities: [
            'Coordinate communication between design teams, clients, vendors, and contractors.',
            'Monitor project timelines and assist in scheduling meetings and deliverables.',
            'Track project milestones, budgets, and documentation for accurate reporting.',
            'Support procurement and logistics of design materials and samples.',
            'Prepare client presentations, progress updates, and project reports.',
            'Ensure adherence to project scopes, deadlines, and quality standards.',
        ],
        qualifications: [
            'Bachelor’s degree in Project Management, Architecture, Interior Design, or related field.',
            '2+ years of experience in project coordination, ideally in design or construction.',
            'Strong organizational, multitasking, and time management skills.',
            'Excellent written and verbal communication abilities.',
            'Proficiency in project management software (e.g., MS Project, Asana, Trello).',
            'Ability to work collaboratively with cross-functional teams and external stakeholders.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Visual Merchandiser',
        details: {
            location: 'Design Studio, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Preferred: 2+ Years in Visual Merchandising or Interior Styling',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'The Visual Merchandiser is responsible for curating captivating and strategic visual presentations that align with brand aesthetics. This role merges creativity and functionality to enhance the visual identity of residential, commercial, or showroom environments.',
        ],
        responsibilities: [
            'Design and implement visual layouts for displays, showrooms, or staging environments.',
            'Collaborate with interior designers and marketing teams to execute visual strategies.',
            'Select furnishings, accessories, lighting, and décor based on project goals.',
            'Ensure that all visual elements are aligned with brand identity and seasonal trends.',
            'Conduct site visits and oversee installation of visual setups.',
            'Maintain presentation standards and make ongoing adjustments as needed.',
        ],
        qualifications: [
            'Degree or certification in Visual Merchandising, Interior Design, or related field.',
            '2+ years of experience in visual merchandising, staging, or styling.',
            'Strong sense of color, spatial planning, and design trends.',
            'Ability to create compelling and customer-focused visual experiences.',
            'Proficiency in design tools (e.g., Adobe Creative Suite, SketchUp).',
            'Excellent communication and time management skills.',
        ],
    }

];

export { positions, benefits, careerIntro };